import { useSelector } from 'react-redux';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import TimeAgoTableCell from 'app/admin/device/component/TimeAgoTableCell';
import PredictionDeviceTableService from '../service/PredictionDeviceTableService';

const config = data => {
	return {
		key: 'predictionDeviceTable',
		text: 'Prediction Device',
		textKey: 'predictionDevice',
		service: PredictionDeviceTableService,
		editFormState: item => `/prediction-device/edit/${item ? item.id : 'new'}`,
		toolbarAction: data.user.isSuperAdmin ? ['filter', 'search', 'refresh', 'new'] : ['search', 'refresh', 'new'],
		rowAction: ['modify', 'delete'],
		filterFields: [
			{
				propertyName: 'project',
				text: 'Project',
				propertyType: 'Long',
				type: 'IN',
				visibleIf: () => data.user.isSuperAdmin
			},
			{
				propertyName: 'deviceType',
				text: 'Device Type',
				propertyType: 'Long',
				type: 'IN'
			},
			{
				propertyName: 'sourceDevice',
				text: 'Source Device',
				propertyType: 'Long',
				type: 'IN'
			}
		],
		columns: [
			{
				key: 'name',
				text: 'Name',
				textKey: 'name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'project.name',
				text: 'Project',
				textKey: 'project.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'deviceType.name',
				text: 'Device Type',
				textKey: 'deviceType.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'sourceDevice.name',
				text: 'Source Device',
				textKey: 'sourceDevice.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'predictionType',
				text: 'Prediction Type',
				textKey: 'predictionType',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'lastSeen',
				text: 'Last Seen',
				textKey: 'lastSeen',
				sortable: false,
				disablePadding: false,
				component: TimeAgoTableCell
			}
		]
	};
};

function PredictionDeviceTable() {
	const user = useSelector(({ auth }) => auth.user);
	const myConfig = config({ user });

	return <TableBrowser config={myConfig} />;
}

export default withReducer('predictionDeviceTable', reducer('predictionDeviceTable'))(PredictionDeviceTable);
